import { getDisplaySubjectLine } from 'find-and-filter-data/view-members-schema/public';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import ReassignmentSelectDropdownContainer from '../../reassignment/ReassignmentSelectDropdownContainer';
import { getThreadListMemberByThreadId } from '../../thread-list-member/selectors/getThreadListMemberByThreadId';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThreadToolbar = ({
  threadId,
  inboxId
}) => {
  const threadListMember = useSelector(state => getThreadListMemberByThreadId(state, {
    threadId
  }));
  const subject = useMemo(() => getDisplaySubjectLine(threadListMember), [threadListMember]);
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    "data-test-id": "thread-toolbar",
    children: [/*#__PURE__*/_jsx(ReassignmentSelectDropdownContainer, {
      threadId: threadId,
      inboxId: inboxId
    }), /*#__PURE__*/_jsx(View, {
      alignSelf: "center",
      paddingBlockEnd: "50",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        truncate: true,
        role: "heading",
        children: subject
      })
    })]
  });
};
ThreadToolbar.displayName = 'ThreadToolbar';
export default ThreadToolbar;